export default "__VITE_ASSET__BRs8Askn__"